import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import DetailsPage from "../components/DetailsPage";

const API_URL = "https://maaapi.balurghatmnc.in/index.php";

function MaaCanteenDetails() {
  const { id, created_by: createdByParam, name } = useParams();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [rows, setRows] = useState([]);
  const [totals, setTotals] = useState({ total_amount: 0, total_tickets: 0 });

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [createdBy] = useState(createdByParam || "");

  const formBody = useMemo(() => {
    const data = new URLSearchParams();
    data.append("modulename", "OrderHistory");
    // created_by is required per latest requirement
    if (createdBy) data.append("created_by", String(createdBy));
    // park_id can be included as well if present (API supports either)
    if (id) data.append("park_id", String(id));
    if (startDate) data.append("start_date", startDate);
    if (endDate) data.append("end_date", endDate);
    return data;
  }, [id, createdBy, startDate, endDate]);

  const fetchData = async (opts = {}) => {
    const { start = startDate, end = endDate } = opts;
    setLoading(true);
    setError("");
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        },
        body: new URLSearchParams({
          modulename: "OrderHistory",
          ...(createdBy ? { created_by: String(createdBy) } : {}),
          ...(id ? { park_id: String(id) } : {}),
          ...(start ? { start_date: start } : {}),
          ...(end ? { end_date: end } : {}),
        }).toString(),
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      if (json.status !== "success") throw new Error("API returned failure");
      setRows(Array.isArray(json.data) ? json.data : []);
      setTotals({
        total_amount: Number(json.total_amount || 0),
        total_tickets: Number(json.total_tickets || 0),
      });
    } catch (e) {
      setError(e.message || "Failed to load");
      setRows([]);
      setTotals({ total_amount: 0, total_tickets: 0 });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const columns = useMemo(
    () => [
      { header: "Date", field: "date" },
      { header: "Ticket No", field: "ticket_no" },
      { header: "Amount", field: "grand_total" },
      { header: "Qty", field: "quantity" },
      { header: "Created By", field: "created_by" },
    ],
    []
  );

  const toYYYYMMDD = (value) => {
    if (!value) return "";
    // if already YYYY-MM-DD, return as-is
    if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;
    // if DD-MM-YYYY convert
    if (/^\d{2}-\d{2}-\d{4}$/.test(value)) {
      const [dd, mm, yyyy] = value.split("-");
      return `${yyyy}-${mm}-${dd}`;
    }
    return value; // fallback
  };

  const handleDateFilterChange = async (start, end) => {
    setStartDate(start);
    setEndDate(end);
    const startNormalized = toYYYYMMDD(start);
    const endNormalized = toYYYYMMDD(end);
    await fetchData({ start: startNormalized, end: endNormalized });
  };

  return (
    <DetailsPage
      title={name ? name : "Maa Canteen Details"}
      backPath="/maa-canteen-report"
      columns={columns}
      data={rows}
      onRowClick={undefined}
      onDateFilterChange={handleDateFilterChange}
      showTotalAmount={true}
      isLoading={loading}
      totalAmount={String(totals.total_amount)}
      dateField="date"
    />
  );
}

export default MaaCanteenDetails;


